import { FC } from "react"
import { colors } from "../../utils/theme"

export type ChartHoverCrosshairBounds = {
  chartHeight: number
  paddingTop: number
  paddingBottom: number
}

/**
 * Vertical guide line at the hovered x (date) position for Victory chart tooltips.
 */
const ChartHoverCrosshair: FC<
  ChartHoverCrosshairBounds & {
    x?: number
  }
> = ({ x, chartHeight, paddingTop, paddingBottom }) => {
  if (x == null || Number.isNaN(x)) {
    return null
  }

  return (
    <line
      x1={x}
      x2={x}
      y1={paddingTop}
      y2={chartHeight - paddingBottom}
      stroke={colors.neutral.cement}
      strokeWidth={1}
      pointerEvents="none"
    />
  )
}

export default ChartHoverCrosshair
